import React, { useEffect, useState } from "react";
import AMap from "../../../../components/amap";
import MessageBox from "../../../../components/message-box";
import request from "../../../../network/request";
import { ISsReserveDetail } from "../../types";
import { isXpAPP } from "../../../../utils/common";
import styles from "./index.module.scss";
import AmapMarker from "../components/AmapMarker";
import { reportUserBehavior } from "../../../../utils/common";
import useGetCh from "../../../../hooks/useGetCh";
import { handleSendToVehicle } from "../../../../utils/location";
import useQuery from "../../../../hooks/useQuery";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import ServiceProgress from "./components/serviceProgress";
import moment from "moment";
import { Link, useHistory, useLocation } from "react-router-dom";

// 预约单详情
export default function ReserveDetail() {
  document.title = "预约详情";
  const query = useQuery();
  const ssReserveOrderCode = query.get("ssReserveOrderCode"); //预约单号（包括取车和无取车）
  const ch = useGetCh();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [orderDetail, setOrderDetail] = useState<ISsReserveDetail | null>(null);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    // console.log(location,history, 'props');
    history.listen((pre) => {
      console.log(location.pathname, pre.pathname, "路由变化");

      if (location.pathname !== pre.pathname) {
        MessageBox.removeAll();
      }
    });
  }, [location]);
  
  useEffect(() => {
    if (!loading && !error) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "move_remote_detail",
          ch,
          pa: `status=success`,
        },
        "page"
      );
    }
  }, [loading, error]);

  const fetchMoveRemoveDetailData = async () => {
    try {
      const res: any = await request(
        "module/maintenance/v3/service/list/getSsReserveOrderDetail",
        {
          ssReserveOrderCode,
        },
        "post"
      );

      setOrderDetail(res);
      window.scrollTo(0, 0);
      reportUserBehavior({
        so: "J001002",
        mcode: "move_remote_detail__req_get_move_remote_order_detail_success",
        ch,
        pa: `status=success\`ssReserveOrderCode=${ssReserveOrderCode}`,
      });
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "move_remote_detail__req_get_move_remote_order_detail_error",
        ch,
        pa: `status=error\`ssReserveOrderCode=${ssReserveOrderCode}`,
      });
      setError(true);
      setErrorMsg((err as any).message || "获取预约订单失败，请稍后重试");
    }
  };

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    setLoading(true);
    setError(false);
    await fetchMoveRemoveDetailData();
    setLoading(false);
  };

  const handleCancel = () => {
    reportUserBehavior({
      so: "J001002",
      mcode: "move_remote_order_detail__click_cancel",
      ch,
      pa: `ssReserveOrderCode=${ssReserveOrderCode}`,
    });

    MessageBox.confirm("确定取消该预约吗？")
      .then(() => {
        console.log(
          "取消预约地址",
          "module/maintenance/reserve/cancel",
          orderDetail?.serviceOrderUuid
        );
        console.log("reserveUuid", orderDetail?.serviceOrderUuid);
        request("module/maintenance/reserve/cancel", {
          reserveUuid: orderDetail?.serviceOrderUuid,
        })
          .then((res: any): any => {
            MessageBox.toast("取消成功");
            reportUserBehavior({
              so: "J001002",
              mcode: "move_remote_order_detail__req_cancel_success",
              ch,
              pa: `ssReserveOrderCode=${ssReserveOrderCode}`,
            });
            // 刷新数据
            getInitData();
          })
          .catch(() => {
            reportUserBehavior({
              so: "J001002",
              mcode: "move_remote_order_detail__req_cancel_error",
              ch,
              pa: `ssReserveOrderCode=${ssReserveOrderCode}`,
            });
            MessageBox.toast("取消失败");
          });
      })
      .catch(() => {
        reportUserBehavior({
          so: "J001002",
          mcode: "move_remote_order_detail__click_cancel_cancel",
          ch,
          pa: `ssReserveOrderCode=${ssReserveOrderCode}`,
        });
        return null;
      });
  };

  // 地图信息
  const mapServiceInfo = (
    <div className={styles.swiperWrapper}>
      <h2>服务门店</h2>
      <div className={styles.mapWrapper}>
        <div className={`${styles.mapInfoContainer} swiper-no-swiping`}>
          <AMap>
            <AmapMarker
              isShopPosition={true}
              shopPosition={{
                lng: orderDetail?.serviceAddress?.longitude || null,
                lat: orderDetail?.serviceAddress?.latitude || null,
              }}
              type={""}
            ></AmapMarker>
          </AMap>
        </div>
        <div className={styles.addressInfo}>
          <div className={styles.addressContainer}>
            <h3 className={styles.name}>{orderDetail?.serviceAddress?.name}</h3>
            <p className={styles.address}>
              {orderDetail?.serviceAddress?.address}
            </p>
            {isXpAPP() && (
              <div
                className={styles.send}
                onClick={() => {
                  handleSendToVehicle(
                    orderDetail?.serviceAddress?.longitude,
                    orderDetail?.serviceAddress?.latitude,
                    orderDetail?.serviceAddress?.name,
                    orderDetail?.serviceAddress?.address
                  );
                  reportUserBehavior({
                    so: "J001002",
                    mcode: "move_remote_detail_click_handleSendToVehicle",
                    ch,
                    pa: `event=发送地址到车\`lat=${orderDetail?.serviceAddress?.latitude}\`lng=${orderDetail?.serviceAddress?.longitude}\`name=${orderDetail?.serviceAddress?.name}\`address=${orderDetail?.serviceAddress?.address}`,
                  });
                }}
              >
                <div className={styles.tip}>发送地址到车</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  // 进度信息
  const progressInfo = orderDetail?.serviceProgress ? (
    <div className={styles.serviceProgressWrapper}>
      <h2>服务进度</h2>
      {orderDetail?.serviceProgress?.map((item, index) => {
        return (
          <ServiceProgress
            content={item}
            firstItem={index === 0}
            key={index}
            lastItem={index === orderDetail?.serviceProgress.length - 1}
          />
        );
      })}
    </div>
  ) : null;

  // 订单信息
  const orderInfo = (
    <div className={styles.orderInfoContainer}>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>
          <h3>预约详情</h3>
        </div>
      </div>
      {/* 服务时间名称 */}
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>{orderDetail?.serviceTimeTitle}</div>
        <div className={styles.cellContent}>
          {moment(orderDetail?.serviceTime).format("YYYY/MM/DD HH:mm")}
        </div>
      </div>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>预约车辆</div>
        <div className={styles.cellContent}>
          {orderDetail?.plateNumber
            ? orderDetail?.plateNumber
            : orderDetail?.vin}
        </div>
      </div>
      {orderDetail?.serviceName && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>移动服务代表</div>
          <div className={styles.cellContent}>{orderDetail?.serviceName}</div>
        </div>
      )}
      {orderDetail?.servicePhone && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>联系电话</div>
          <div className={styles.cellContent}>
            <a href={`tel:${orderDetail?.servicePhone}`}>
              {orderDetail?.servicePhone}
            </a>
          </div>
        </div>
      )}
      {orderDetail?.ssReserveOrderCode && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>服务单号</div>
          <div className={styles.cellContent}>
            {orderDetail?.ssReserveOrderCode}
          </div>
        </div>
      )}
      {orderDetail?.surroundCheckPhotoList &&
        orderDetail?.surroundCheckPhotoList?.length > 0 && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>环车检查照片</div>
            <div className={styles.cellContent}>
              <Link
                to={{
                  pathname: "/serviceOrders/preview",
                  state: {
                    imgList: orderDetail?.surroundCheckPhotoList,
                    title: "环车检查照片",
                  },
                }}
              >
                <button
                  className={styles.pictureViewBtn}
                  onClick={() => {
                    reportUserBehavior({
                      so: "J001005",
                      mcode: "move_remote_detail__click_surround_preview",
                      ch,
                      pa: "",
                    });
                  }}
                >
                  查看
                </button>
              </Link>
            </div>
          </div>
        )}
      {orderDetail?.surroundCheckRemark && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>环车检查备注</div>
          <div className={styles.cellContent}>
            {orderDetail?.surroundCheckRemark}
          </div>
        </div>
      )}
    </div>
  );

  const cancelOpt = orderDetail?.allowCancel ? (
    <div className={styles.scheduleCancelContainer}>
      <div className={styles.scheduleOpt}>
        <button className={styles.cancelScheduleBtn} onClick={handleCancel}>
          取消预约
        </button>
      </div>
    </div>
  ) : null;

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "move_remote_detail",
        ch,
        pa: `status=error`,
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div className={styles.detailPageWrapper}>
      {mapServiceInfo}
      {orderInfo}
      {progressInfo}
      {cancelOpt}
    </div>
  );
}
